import axios from 'axios';

const api = axios.create({
  baseURL: 'https://manual.mminfo.me/api'
});

export default api;